import { render, staticRenderFns } from "./SuccessfullyCreatedNotice.vue?vue&type=template&id=efb13720"
import script from "./SuccessfullyCreatedNotice.vue?vue&type=script&lang=ts"
export * from "./SuccessfullyCreatedNotice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports